import React from 'react';
import { Box, Button, Chip, IconButton, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import BusinessIcon from '@mui/icons-material/Business';

const DEFAULT_ACCENT = '#4ce1b6';

export default function CompanyDetailsHeadingActions({
  hasCompanyDetails,
  companyName,
  isDark,
  onEdit,
  onRemove,
  accent = DEFAULT_ACCENT,
  addLabel = 'Add Company Details',
  chipSeparator = '•',
  chipSize = 'medium',
  fullWidthAdd = false,
}) {
  const chipLabel = `Corporate ${chipSeparator} ${companyName || 'Company details added'}`;

  const chipSx =
    chipSize === 'small'
      ? {
          border: `1px solid ${alpha(accent, 0.5)}`,
          fontWeight: 600,
          alignSelf: 'flex-start',
          maxWidth: '100%',
        }
      : {
          backgroundColor: isDark ? '#333246' : '#e8f5e9',
          color: isDark ? accent : '#1b5e20',
          border: `1px solid ${isDark ? accent : '#66bb6a'}`,
        };

  const editIconButtonSx = {
    color: accent,
    width: 28,
    height: 28,
    '&:hover': {
      backgroundColor: isDark ? 'rgba(76, 225, 182, 0.15)' : 'rgba(76, 225, 182, 0.1)',
    },
  };

  const deleteIconButtonSx = {
    color: isDark ? '#f87171' : '#c62828',
    width: 28,
    height: 28,
    '&:hover': {
      backgroundColor: isDark ? 'rgba(248, 113, 113, 0.15)' : 'rgba(198, 40, 40, 0.08)',
    },
  };

  if (hasCompanyDetails) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.25,
          flexWrap: 'wrap',
          width: fullWidthAdd ? '100%' : 'auto',
        }}
      >
        <Chip label={chipLabel} size={chipSize} sx={chipSx} />
        <Tooltip title="Edit company details">
          <IconButton size="small" onClick={onEdit} aria-label="Edit company details" sx={editIconButtonSx}>
            <EditIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Remove company">
          <IconButton size="small" onClick={onRemove} aria-label="Remove company" sx={deleteIconButtonSx}>
            <DeleteOutlineIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      </Box>
    );
  }

  return (
    <Button
      variant="outlined"
      size={chipSize === 'small' ? 'small' : 'medium'}
      fullWidth={fullWidthAdd}
      onClick={onEdit}
      startIcon={<BusinessIcon fontSize="small" />}
      sx={{
        borderColor: accent,
        color: accent,
        width: fullWidthAdd ? '100%' : { xs: '100%', sm: 'auto' },
        '&:hover': {
          borderColor: accent,
          backgroundColor: isDark ? '#333246' : '#f5f5f5',
        },
      }}
    >
      {addLabel}
    </Button>
  );
}
